import { render, staticRenderFns } from "./YourAccount.vue?vue&type=template&id=ffc0efe6&scoped=true&"
import script from "./YourAccount.vue?vue&type=script&lang=ts&"
export * from "./YourAccount.vue?vue&type=script&lang=ts&"
import style0 from "./YourAccount.vue?vue&type=style&index=0&id=ffc0efe6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc0efe6",
  null
  
)

export default component.exports